require('./ratingRiskTab.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const moment = require('moment');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { StarsRating } = require('commonsComponents/starsRating');
const { OKLink } = require('commonsComponents/OKLink');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { DATE_FORMAT_ES,
        BROKER_OUR_METHODOLOGY_URL } = require('constants/index');

class RatingRiskTab extends React.Component {
    constructor(props) {
        super(props);
        this.buildMorningStarRatingRows = this.buildMorningStarRatingRows.bind(this);
    }

    getRatingText(rating) {
        const PREFIX = 'broker-ratingRiskText';
        const riskRatings = {
            '1': formatText(`${PREFIX}Baja`),
            '2': formatText(`${PREFIX}DebajoMedia`),
            '3': formatText(`${PREFIX}Media`),
            '4': formatText(`${PREFIX}SobreMedia`),
            '5': formatText(`${PREFIX}Alta`)
        };
        return riskRatings[rating];
    }

    buildMorningStarRatingRows() {
        const { product } = this.props;
        const TOTAL_STARS = 5;
        const morningStarRatings = product.get('riskAndRating') || [];

        return morningStarRatings.map((rating, index) => {
            return (
                <OKTableRow key={index}>
                    <OKTableCell className="rating-risk-tab__table-rating-cell rating-risk-tab__table-rating-cell--first-column">
                        {this.convertPeriod(rating.get('TimePeriod'))}
                    </OKTableCell>
                    <OKTableCell className="rating-risk-tab__table-rating-cell">
                        {this.getRatingText(rating.get('PerformanceRatingValue'))}
                    </OKTableCell>
                    <OKTableCell className="rating-risk-tab__table-rating-cell">
                        {this.getRatingText(rating.get('RiskRatingValue'))}
                    </OKTableCell>
                    <OKTableCell className="rating-risk-tab__table-rating-cell">
                        <StarsRating
                            total={TOTAL_STARS}
                            actual={rating.get('RatingValue')}
                        />
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    convertPeriod(timePeriod) {
        const PREFIX = 'broker-convertPeriod';
        const periods = {
            'M36': formatText(`${PREFIX}3Years`),
            'M60': formatText(`${PREFIX}5Years`),
            'M120': formatText(`${PREFIX}10Years`),
            'M255': formatText(`${PREFIX}Global`)
        };
        return periods[timePeriod];
    }

    render() {
        const PREFIX = 'broker-ratingRiskTab'

        const ratingMorningStarTitle = formatText(`${PREFIX}RatingMorningStarTitle`);
        const profitabilityLabel = formatText(`${PREFIX}ProfitabilityLabel`);
        const riskLabel = formatText(`${PREFIX}RiskLabel`);
        const ratingLabel = formatText(`${PREFIX}RatingLabel`);
        const profitabilityRiskTitle = formatText(`${PREFIX}ProfitabilityRiskTitle`);
        const riskMeasureLabel = formatText(`${PREFIX}RiskMeasureLabel`);
        const oneYearLabel = formatText(`${PREFIX}OneYearLabel`);
        const twoYearsLabel = formatText(`${PREFIX}TwoYearsLabel`);
        const fiveYearsLabel = formatText(`${PREFIX}FiveYearsLabel`);
        const standardDeviationsLabel = formatText(`${PREFIX}StandardDeviationsLabel`);
        const profitabilityAverageLabel = formatText(`${PREFIX}ProfitabilityAverageLabel`);
        const sharpeRatioLabel = formatText(`${PREFIX}SharpeRatioLabel`);
        const sortinoRatioLabel = formatText(`${PREFIX}SortinoRatioLabel`);
        const positiveMonthsLabel = formatText(`${PREFIX}PositiveMonthsLabel`);
        const negativeMonthsLabel = formatText(`${PREFIX}NegativeMonthsLabel`);
        const worstMonthLabel = formatText(`${PREFIX}WorstMonthLabel`);
        const walletStatisticTitle = formatText(`${PREFIX}WalletStatisticTitle`);
        const indexesLabel = formatText(`${PREFIX}StandardIndexesLabel`);
        const MSCISpainNREurLabel = formatText(`${PREFIX}MSCISpainNREurLabel`);
        const adjustIndexLabel = formatText(`${PREFIX}AdjustIndexLabel`);
        const spainIBEXNREur = formatText(`${PREFIX}SpainIBEXNREur`);
        const threeYrRSquared = formatText(`${PREFIX}3YrRSquared`);
        const threeYrRBeta = formatText(`${PREFIX}3YrRBeta`);
        const threeYrRAlpha = formatText(`${PREFIX}3YrRAlpha`);
        const categoryBenchmark = formatText(`${PREFIX}BenchmarkCategory`);

        const { product } = this.props;

        const ratingDate = product.getIn(['riskAndRating', 0, 'Date']);
        const riskStatisticDate = product.getIn(['riskStatistics', 'date']);
        const stardardDesviations = product.getIn(['riskStatistics', 'standardDeviations']);
        const averageProfitability = product.getIn(['riskStatistics', 'averageProfitability']);
        const sharpeRatios = product.getIn(['riskStatistics', 'sharpeRatios']);
        const sortinoRatios = product.getIn(['riskStatistics', 'sortinoRatios']);
        const numberOfPositives = product.getIn(['riskStatistics', 'numberOfPositives']);
        const numberOfNegatives = product.getIn(['riskStatistics', 'numberOfNegatives']);
        const minimumReturns = product.getIn(['riskStatistics', 'minimumReturns']);
        const benchmarkName = `${categoryBenchmark}: ${product.getIn(['benchmark', 'name'])}`;
        const rSquareds = product.getIn(['riskStatistics', 'rSquareds']);
        const betas = product.getIn(['riskStatistics','betas']);
        const alphas = product.getIn(['riskStatistics', 'alphas']);
        const bestFits = product.getIn(['riskStatistics', 'bestFits']);

        const morningStarRatingsRows = this.buildMorningStarRatingRows();

        const rSquaredsValue = rSquareds && rSquareds.getIn([0, 'Value']) ? formatAmount(rSquareds.getIn([0, 'Value'])) + '%' : '-';
        const rSquaredBestFit = bestFits && bestFits.getIn([0, 'RSquared']) ? formatAmount(bestFits.getIn([0, 'RSquared'])) + '%' : '-';

        const rBetasValue = betas && betas.getIn([0, 'Value']) ? formatAmount(betas.getIn([0, 'Value'])) + '%' :  '-';
        const rBetasBestFit = bestFits && bestFits.getIn([0, 'Beta']) ? formatAmount(bestFits.getIn([0, 'Beta'])) + '%' : '-' ;

        const rAlphasValue = alphas && alphas.getIn([0, 'Value']) ? formatAmount(alphas.getIn([0, 'Value'])) + '%' : '-';
        const rAlphasBestFit = bestFits && bestFits.getIn([0, 'Alpha']) ? formatAmount(bestFits.getIn([0, 'Alpha'])) + '%' : '-';

        return (
            <div className="rating-risk-tab">
                <section className="rating-risk-tab__section">
                    <header className="rating-risk-tab__section-header">
                        <h2 className="rating-risk-tab__section-title">
                            {ratingMorningStarTitle}
                        </h2>
                        <div className="rating-risk-tab__date-container">
                            <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                            <span className="rating-risk-tab__date">
                                {moment(ratingDate).format(DATE_FORMAT_ES)}
                            </span>
                        </div>
                    </header>

                    <OKTable
                        id="account-chequebook-movements"
                        className="rating-risk-tab__table"
                    >
                        <OKTableRow
                            asHeader={true}
                            className="rating-risk-tab__table-header-row"
                        >
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-rating-header-cell rating-risk-tab__table-rating-header-cell--first-column"
                            />
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-rating-header-cell rating-risk-tab__table-rating-header-cell--second-column"
                            >
                                {profitabilityLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-rating-header-cell rating-risk-tab__table-rating-header-cell--third-column"
                            >
                                {riskLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-rating-header-cell rating-risk-tab__table-rating-header-cell--forth-column"
                            >
                                {ratingLabel}
                            </OKTableCell>
                        </OKTableRow>

                        {morningStarRatingsRows}
                    </OKTable>

                    <footer className="rating-risk-tab__section-footer">
                        <span>
                            {benchmarkName}
                        </span>
                        <div className="rating-risk-tab__section-footer-link-wrapper">
                            <OKLink
                                modifier="emphasize"
                                id="lnkRatingRiskTabOurMethodology"
                                to={BROKER_OUR_METHODOLOGY_URL}
                                target="_blank"
                            >
                                <FormattedText value={`${PREFIX}OurMethodologyLink`} />
                            </OKLink>
                        </div>
                    </footer>
                </section>

                <section className="rating-risk-tab__section">
                    <header className="rating-risk-tab__section-header">
                        <h2 className="rating-risk-tab__section-title">
                            {profitabilityRiskTitle}
                        </h2>
                        <div className="rating-risk-tab__date-container">
                            <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                            <span className="rating-risk-tab__date">
                                {moment(riskStatisticDate).format(DATE_FORMAT_ES)}
                            </span>
                        </div>
                    </header>

                    <OKTable id="account-chequebook-movements">
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-risk-header-cell rating-risk-tab__table-risk-header-cell--first-column"
                            >
                                {riskMeasureLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-risk-header-cell rating-risk-tab__table-risk-header-cell--second-column"
                            >
                                {oneYearLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-risk-header-cell rating-risk-tab__table-risk-header-cell--third-column"
                            >
                                {twoYearsLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-risk-header-cell rating-risk-tab__table-risk-header-cell--forth-column"
                            >
                                {fiveYearsLabel}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {standardDeviationsLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(stardardDesviations.get('m12')) !== '' ? formatAmount(stardardDesviations.get('m12')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(stardardDesviations.get('m36')) !== '' ? formatAmount(stardardDesviations.get('m36')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(stardardDesviations.get('m60')) !== '' ? formatAmount(stardardDesviations.get('m60')) + '%' : '-'}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {profitabilityAverageLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(averageProfitability.get('m12')) !== '' ? formatAmount(averageProfitability.get('m12')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(averageProfitability.get('m36')) !== '' ? formatAmount(averageProfitability.get('m36')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(averageProfitability.get('m60')) !== '' ? formatAmount(averageProfitability.get('m60')) + '%' : '-'}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {sharpeRatioLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(sharpeRatios.get('m12')) !== '' ? formatAmount(sharpeRatios.get('m12')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(sharpeRatios.get('m36')) !== '' ? formatAmount(sharpeRatios.get('m36')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(sharpeRatios.get('m60')) !== '' ? formatAmount(sharpeRatios.get('m60')) + '%' : '-'}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {sortinoRatioLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(sortinoRatios.get('m12')) !== '' ? formatAmount(sortinoRatios.get('m12')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(sortinoRatios.get('m36')) !== '' ? formatAmount(sortinoRatios.get('m36')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(sortinoRatios.get('m60')) !== '' ? formatAmount(sortinoRatios.get('m60')) + '%' : '-'}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {positiveMonthsLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {numberOfPositives.get('m12') || '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {numberOfPositives.get('m36') || '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {numberOfPositives.get('m60') || '-'}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {negativeMonthsLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {numberOfNegatives.get('m12') || '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {numberOfNegatives.get('m36') || '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {numberOfNegatives.get('m60') || '-'}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-risk-cell rating-risk-tab__table-risk-cell--first-column">
                                {worstMonthLabel}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(minimumReturns.get('m12')) !== '' ? formatAmount(minimumReturns.get('m12')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(minimumReturns.get('m36')) !== '' ? formatAmount(minimumReturns.get('m36')) + '%' : '-'}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-risk-cell">
                                {formatAmount(minimumReturns.get('m60')) !== '' ? formatAmount(minimumReturns.get('m60')) + '%' : '-'}
                            </OKTableCell>
                        </OKTableRow>
                    </OKTable>
                </section>

                <section className="rating-risk-tab__section">
                    <header className="rating-risk-tab__section-header">
                        <h2 className="rating-risk-tab__section-title">
                            {walletStatisticTitle}
                        </h2>
                        <div className="rating-risk-tab__date-container">
                            <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                            <span className="rating-risk-tab__date">
                                {moment(riskStatisticDate).format(DATE_FORMAT_ES)}
                            </span>
                        </div>
                    </header>

                    <OKTable id="account-chequebook-movements">
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-statistic-header-cell rating-risk-tab__table-statistic-header-cell--first-column"
                            />
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-statistic-header-cell rating-risk-tab__table-statistic-header-cell--second-column"
                            >
                                <div>
                                    {indexesLabel}
                                </div>
                                <hr className="rating-risk-tab__divider-standard" />
                                <div className="rating-risk-tab__underline-word">
                                    {MSCISpainNREurLabel}
                                </div>
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="rating-risk-tab__table-statistic-header-cell rating-risk-tab__table-statistic-header-cell--third-column"
                            >
                                <div>
                                    {adjustIndexLabel}
                                </div>
                                <hr className="rating-risk-tab__divider-adjust" />
                                <div>
                                    <div className="rating-risk-tab__underline-word">
                                        {spainIBEXNREur}
                                    </div>
                                </div>
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell rating-risk-tab__table-statistic-cell--first-column">
                                {threeYrRSquared}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell">
                                {rSquaredsValue}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell">
                                {rSquaredBestFit}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell rating-risk-tab__table-statistic-cell--first-column">
                                {threeYrRBeta}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell">
                                {rBetasValue}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell">
                                {rBetasBestFit}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell rating-risk-tab__table-statistic-cell--first-column">
                                {threeYrRAlpha}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell">
                                {rAlphasValue}
                            </OKTableCell>
                            <OKTableCell className="rating-risk-tab__table-statistic-cell">
                                {rAlphasBestFit}
                            </OKTableCell>
                        </OKTableRow>
                    </OKTable>
                </section>
            </div>
        );
    }
}


RatingRiskTab.propTypes = {
    product: PropTypes.object
};

module.exports = RatingRiskTab;
